module.exports = __webpack_public_path__ + "static/media/image-6.3f83e449.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-6.png
// module id = 256
// module chunks = 0